module.exports = __webpack_public_path__ + "media/phone@2x-fa92728e.png";